import { createSlice } from '@reduxjs/toolkit';

interface InitialState {
  selectedUser: number | null;
}

export const userSlice = createSlice({
  name: 'userSlice',
  initialState: {
    selectedUser: null,
  } as InitialState,
  reducers: {
    selectedUserChanged: (state, { payload }) => {
      state.selectedUser = payload;
    },
  },
});

export default userSlice.reducer;
